import {observer, PropTypes as MobXPropTypes} from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import BookNowButton from 'core/components/BookNowButton.js';
import CollapsibleNumber from 'core/components/CollapsibleNumber.js';

import Link from 'core/components/Link.js';
import autobind from 'common/decorators/autobind.js';
import {DirectoryStoreContext} from 'core/stores/RootStore.js';
import {openLinkInNewTab, browserCheckForIE11} from 'core/utils.js';

import {
    HICAPS,
    TELEHEALTH,
    PRACTICE_LOC_CONTACT_TYPE,
    TOOLTIP_TELEHEALTH_TEXT,
    TOOLTIP_HICAPS_TEXT,
    DIRECTORY_SEARCH_RESULT_CARD_LINK,
    PRACTICE_LOCATION_CARD,
    AVATAR_SIZE_DEFAULT,
    AVATAR_SIZE_LARGE,
} from 'core/constants.js';

import {Card, Chip, Pill} from '@HealthShareAU/hs-component-library';
export default
@observer
class PracticeLocation extends React.Component {
    static contextType = DirectoryStoreContext;
    static propTypes = {
        address: PropTypes.string,
        avatar: PropTypes.string,
        bookingsEnabled: MobXPropTypes.arrayOrObservableArrayOf(
            PropTypes.string,
        ),
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        offersTelehealth: PropTypes.bool,
        phones: MobXPropTypes.arrayOrObservableArrayOf(
            PropTypes.shape({
                number: PropTypes.string.isRequired,
            }),
        ),
        url: PropTypes.string,
    };

    static defaultProps = {
        offersTelehealth: false,
        bookingsEnabled: [],
    };

    constructor(props) {
        super(props);

        this.state = {
            modalDisplayed: false,
        };
        const {id, address, name, phones} = this.props;
        const loc = {
            id,
            address,
            name,
            phones,
            type: PRACTICE_LOC_CONTACT_TYPE,
        };
        this.modalProps = {
            closeModal: this.closeModal,
            contactId: id,
            contactName: name,
            contactType: PRACTICE_LOC_CONTACT_TYPE,
            items: [loc],
            phoneNumber: phones[0]?.number,
        };
    }

    @autobind
    closeModal() {
        this.setState({modalDisplayed: false});
    }

    @autobind
    handlePhoneClick() {
        this.setState({modalDisplayed: true});
    }

    renderPhoneNumber() {
        const {name, phones} = this.props;
        const phone = phones[0];
        if (!phone?.number) {
            return null;
        }
        return (
            <Chip
                customClass="chip-phone"
                icon="phone"
                key="chip-phone"
                linkComponent={
                    <CollapsibleNumber
                        number={phone.number}
                        onClick={this.handlePhoneClick}
                        title={`Click to show phone number for ${name}`}
                    />
                }
            />
        );
    }

    renderAddress() {
        return (
            <Chip
                customClass="chip-address"
                icon="address"
                key="chip-address"
                text={this.props.address}
            />
        );
    }

    renderBookNowButton() {
        const {bookingsEnabled, customBookingDataUrl, id} = this.props;
        if (bookingsEnabled.length > 0) {
            return (
                <BookNowButton
                    gaObjectType={PRACTICE_LOCATION_CARD}
                    objectId={id}
                    objectType="directory practice location result"
                    params={{'practice_location': id}}
                />
            );
        } else if (customBookingDataUrl) {
            return (
                <BookNowButton
                    action={() => openLinkInNewTab(customBookingDataUrl)}
                    gaObjectType={PRACTICE_LOCATION_CARD}
                    params={{'practice_location': id}}
                    objectId={id}
                    objectType="directory practice location result"
                />
            );
        }
    }
    renderSpecialty() {
        const {
            specialty,
            rootStore: {
                paramStore: {isProUser, isReferrals},
            },
        } = this.context;
        if (!specialty) {
            return null;
        }
        return isReferrals || isProUser
            ? specialty.professionalName
            : specialty.name;
    }

    render() {
        const {
            avatar,
            bookingsEnabled,
            customBookingDataUrl,
            hasHicaps,
            name,
            url,
            offersTelehealth,
        } = this.props;

        const {
            renderModal,
            specialty,
            telehealthDirectory,
            rootStore: {
                paramStore: {isClient},
            },
        } = this.context;
        const {modalDisplayed} = this.state;

        const directoryCardProps = {
            avatarIconType: 'address',
            avatarSizeTablet: isClient
                ? AVATAR_SIZE_DEFAULT
                : AVATAR_SIZE_LARGE,
            avatarSource: avatar && avatar,
            bookingModule: (bookingsEnabled.length > 0 ||
                customBookingDataUrl) && (
                <div className="hs-button-container">
                    {this.renderBookNowButton()}
                </div>
            ),
            chips: [
                this.props.address && this.renderAddress(),
                this.renderPhoneNumber(),
            ],
            dataTestId: 'practiceLocation',
            description: '',
            heading: name,
            isFeatured: false,
            isIntegrated: isClient,
            pills: (offersTelehealth || hasHicaps) && [
                offersTelehealth && (
                    <Pill
                        key="telehealth"
                        text={TELEHEALTH}
                        tooltip={
                            browserCheckForIE11()
                                ? null
                                : TOOLTIP_TELEHEALTH_TEXT
                        }
                    />
                ),
                hasHicaps && (
                    <Pill
                        key="hicaps"
                        text={HICAPS}
                        tooltip={
                            browserCheckForIE11() ? null : TOOLTIP_HICAPS_TEXT
                        }
                    />
                ),
            ],
            size: 'default',
            subHeading: this.renderSpecialty(),
        };
        return (
            <li
                className={`cell ${
                    telehealthDirectory ? 'telehealth-directory' : ''
                }`.trim()}
            >
                {modalDisplayed && renderModal(this.modalProps)}
                <Link
                    customClass="card-link"
                    gaObjectType={PRACTICE_LOCATION_CARD}
                    gaSelector={DIRECTORY_SEARCH_RESULT_CARD_LINK}
                    href={url}
                >
                    <span>{`${name} practice link`}</span>
                </Link>
                <Card {...directoryCardProps} />
            </li>
        );
    }
}
